<!--
  @Author: DKing
  @Desc: 下载组件,
  @Date: 2019-09-02
-->

<template>
  <span :class="className" @click="xhrDownloadFile()"
  :url="interfaceUrl"
  :key="keyName"
  :downloadPath="downloadPath"
  >{{text}}</span>
</template>

<script>
  import {checkNull, getLocal} from "../filters/filters";
  import {getFileDownLoad} from "../service/apis";

  export default {
    name: "download-button",

    props: {
      // 下载文件的路径
      downloadPath:String,
      text: {
        type: String,
        default: '点击下载'
      },
      className: {
        type: String,
        default: 'btnNoBorderBlue'
      },
      interfaceUrl:{
        type: String,
        default: getFileDownLoad
      },
      // 下载地址的key值
      keyName:{
        type:String,
        default: 'key'
      },

      // 0：下载 1：打开
      openType: {
        type: Number,
        default: 0
      }
    },
    components: {},

    computed: {},

    data() {
      return {
      }
    },

    created() {

    },

    mounted() {
    },

    methods: {
      // xhr -- 导出文件
      xhrDownloadFile() {
        // 是否含有url
        if (checkNull(this.downloadPath)) {
          return
        }

        let url = '';
        if(this.downloadPath.indexOf('http') > -1){
          url = this.downloadPath
        } else{
          url = this.interfaceUrl + '?' +this.keyName + '=' + this.downloadPath
        }


        if(this.openType == 1){
          url = url + '&open=' + this.openType
        }

        window.open(url + '&token=' + getLocal('Authorization'));
      }
    }
  }
</script>
 


// WEBPACK FOOTER //
// src/components/downloadButton.vue